<template>
  <div
    style="
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 0;
      border-radius: 8px;
      overflow: hidden;
    "
  >
    <img
      v-if="type == 'image'"
      :src="image"
      style="width: 100%; height: 100%; object-fit: cover"
    />

    <!-- Type 1 or Default -->
    <svg
      v-if="type == 1"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="diagonal-lines"
          x="0"
          y="0"
          width="20"
          height="20"
          patternUnits="userSpaceOnUse"
        >
          <line
            x1="0"
            y1="20"
            x2="20"
            y2="0"
            stroke="#FFFFFF"
            stroke-width="0.5"
            opacity="0.2"
          />
          <line
            x1="0"
            y1="0"
            x2="20"
            y2="20"
            stroke="#FFFFFF"
            stroke-width="0.5"
            opacity="0.2"
          />
        </pattern>
      </defs>
      <rect x="0" y="0" width="100" height="100" fill="url(#diagonal-lines)" />
    </svg>

    <!-- Type 2 -->
    <svg
      v-if="type == 2"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="honeycomb-pattern"
          x="0"
          y="0"
          width="24"
          height="28"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M12 0 L24 7 L24 21 L12 28 L0 21 L0 7 Z"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="0.5"
            opacity="0.2"
          />
          <path
            d="M12 0 L24 7 L24 21 L12 28 L0 21 L0 7 Z"
            fill="none"
            stroke="#FFFFFF"
            stroke-width="0.5"
            opacity="0.1"
            transform="translate(12, 14)"
          />
        </pattern>
      </defs>
      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="url(#honeycomb-pattern)"
      />
    </svg>

    <!-- Type 3 -->
    <svg
      v-if="type == 3"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="waveGradient2" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.2" />
          <stop offset="50%" stop-color="#FFFFFF" stop-opacity="0.06" />
          <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0.2" />
        </linearGradient>

        <pattern
          id="soft-wave-pattern"
          x="0"
          y="0"
          width="150"
          height="80"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M0 40 C 37.5 10, 112.5 70, 150 40"
            stroke="url(#waveGradient2)"
            stroke-width="1.5"
            fill="none"
          />
          <path
            d="M0 50 C 37.5 80, 112.5 20, 150 50"
            stroke="url(#waveGradient2)"
            stroke-width="1.5"
            fill="none"
          />
        </pattern>
      </defs>
      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="url(#soft-wave-pattern)"
      />
    </svg>

    <!-- Type 4 -->
    <svg
      v-if="type == 4"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="data-flow-pattern"
          x="0"
          y="0"
          width="30"
          height="30"
          patternUnits="userSpaceOnUse"
        >
          <line
            x1="0"
            y1="5"
            x2="10"
            y2="15"
            stroke="#FFFFFF"
            stroke-width="0.3"
            opacity="0.2"
          />
          <line
            x1="15"
            y1="10"
            x2="25"
            y2="0"
            stroke="#FFFFFF"
            stroke-width="0.3"
            opacity="0.2"
          />
          <line
            x1="5"
            y1="25"
            x2="15"
            y2="15"
            stroke="#FFFFFF"
            stroke-width="0.3"
            opacity="0.2"
          />
          <line
            x1="20"
            y1="30"
            x2="30"
            y2="20"
            stroke="#FFFFFF"
            stroke-width="0.3"
            opacity="0.2"
          />

          <line
            x1="0"
            y1="20"
            x2="10"
            y2="10"
            stroke="#FFFFFF"
            stroke-width="0.3"
            opacity="0.1"
          />
          <line
            x1="15"
            y1="25"
            x2="25"
            y2="15"
            stroke="#FFFFFF"
            stroke-width="0.3"
            opacity="0.1"
          />
          <line
            x1="5"
            y1="0"
            x2="15"
            y2="10"
            stroke="#FFFFFF"
            stroke-width="0.3"
            opacity="0.1"
          />
          <line
            x1="20"
            y1="5"
            x2="30"
            y2="15"
            stroke="#FFFFFF"
            stroke-width="0.3"
            opacity="0.1"
          />
        </pattern>
      </defs>
      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="url(#data-flow-pattern)"
      />
    </svg>

    <!-- Type 5 -->
    <svg
      v-if="type == 5"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="concentric-rings-pattern"
          x="0"
          y="0"
          width="80"
          height="80"
          patternUnits="userSpaceOnUse"
        >
          <circle
            cx="40"
            cy="40"
            r="10"
            stroke="#FFFFFF"
            stroke-width="0.3"
            fill="none"
            opacity="0.2"
          />
          <circle
            cx="40"
            cy="40"
            r="20"
            stroke="#FFFFFF"
            stroke-width="0.3"
            fill="none"
            opacity="0.16"
          />
          <circle
            cx="40"
            cy="40"
            r="30"
            stroke="#FFFFFF"
            stroke-width="0.3"
            fill="none"
            opacity="0.12"
          />
          <circle
            cx="40"
            cy="40"
            r="40"
            stroke="#FFFFFF"
            stroke-width="0.3"
            fill="none"
            opacity="0.1"
          />
        </pattern>
      </defs>
      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="url(#concentric-rings-pattern)"
      />
    </svg>

    <!-- Type 6 -->
    <svg
      v-if="type == 6"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="noise-pattern"
          x="0"
          y="0"
          width="4"
          height="4"
          patternUnits="userSpaceOnUse"
        >
          <circle cx="1" cy="1" r="0.2" fill="#FFFFFF" opacity="0.16" />
          <circle cx="3" cy="3" r="0.15" fill="#FFFFFF" opacity="0.12" />
          <circle cx="1.5" cy="3.5" r="0.1" fill="#FFFFFF" opacity="0.08" />
          <circle cx="3.5" cy="1.5" r="0.25" fill="#FFFFFF" opacity="0.18" />
        </pattern>
      </defs>
      <rect x="0" y="0" width="100" height="100" fill="url(#noise-pattern)" />
    </svg>

    <!-- Type 7 -->
    <svg
      v-if="type == 7"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="wide-diagonal-stripes"
          x="0"
          y="0"
          width="40"
          height="40"
          patternUnits="userSpaceOnUse"
        >
          <line
            x1="-10"
            y1="50"
            x2="50"
            y2="-10"
            stroke="#FFFFFF"
            stroke-width="3"
            opacity="0.1"
          />
        </pattern>
      </defs>
      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="url(#wide-diagonal-stripes)"
      />
    </svg>

    <!-- Type 8 -->
    <svg
      v-if="type == 8"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="overlapping-circles"
          x="0"
          y="0"
          width="50"
          height="50"
          patternUnits="userSpaceOnUse"
        >
          <circle cx="10" cy="10" r="8" fill="#FFFFFF" opacity="0.08" />
          <circle cx="40" cy="10" r="8" fill="#FFFFFF" opacity="0.08" />
          <circle cx="25" cy="35" r="8" fill="#FFFFFF" opacity="0.08" />
          <circle cx="10" cy="40" r="8" fill="#FFFFFF" opacity="0.08" />
          <circle cx="40" cy="40" r="8" fill="#FFFFFF" opacity="0.08" />
        </pattern>
      </defs>
      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="url(#overlapping-circles)"
      />
    </svg>

    <!-- Type 9 -->
    <svg
      v-if="type == 9"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="waterWaveGradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
        >
          <stop offset="0%" stop-color="#FFFFFF" stop-opacity="0.1" />
          <stop offset="50%" stop-color="#FFFFFF" stop-opacity="0.03" />
          <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0.1" />
        </linearGradient>

        <pattern
          id="water-wave-pattern"
          x="0"
          y="0"
          width="120"
          height="60"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M0 30 C 30 10, 90 50, 120 30"
            stroke="url(#waterWaveGradient)"
            stroke-width="1.2"
            fill="none"
          />
          <path
            d="M0 40 C 30 20, 90 60, 120 40"
            stroke="url(#waterWaveGradient)"
            stroke-width="0.8"
            fill="none"
            opacity="0.7"
          />
        </pattern>
      </defs>
      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="url(#water-wave-pattern)"
      />
    </svg>

    <!-- Type 10 -->
    <svg
      v-if="type == 10"
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="retro-grid-pattern"
          x="0"
          y="0"
          width="15"
          height="15"
          patternUnits="userSpaceOnUse"
        >
          <line
            x1="0"
            y1="0"
            x2="15"
            y2="0"
            stroke="#FFFFFF"
            stroke-width="0.5"
            opacity="0.1"
          />
          <line
            x1="0"
            y1="0"
            x2="0"
            y2="15"
            stroke="#FFFFFF"
            stroke-width="0.5"
            opacity="0.1"
          />
        </pattern>
      </defs>
      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="url(#retro-grid-pattern)"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    type: { default: 1 },
    image: { default: "https://picsum.photos/id/74/1000/1000" },
  },
};
</script>

<style scoped>
</style>
